import { Tabs } from "@ofqual/portal-components/components/Tabs";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { authSelector } from "../../redux/selectors";

export const ListTabs: React.FC = () => {
  const { experimentalFeatures } = useAuth(authSelector);
  const { push } = useHistory();
  const noTabs: { id: string, label: string, dataTest: string }[] = [];
  const year = useLocation().pathname.split('/')[2];

  const tabConfigs = [
    { id: "2025", label: "SOC 2025", dataTest: "soc-2025-tab", moduleName: "portal-soc/v2", featureName: "portal-soc-tab-2025" },
    { id: "2024", label: "SOC 2024", dataTest: "soc-2024-tab", moduleName: "portal-soc/v2", featureName: "portal-soc-tab-2024" },
    { id: "2023", label: "SoC 2023", dataTest: "soc-2023-tab", moduleName: "portal-soc/2023", featureName: "portal-soc-tabs" },
    { id: "2022", label: "SoC 2022", dataTest: "soc-2022-tab", moduleName: "portal-soc/2022", featureName: "portal-soc-tabs" },
  ];

  const getTabs = () => {
    if (!experimentalFeatures) return [];
    return tabConfigs.filter(tab =>
      experimentalFeatures.some(
        x => x.moduleName === tab.moduleName && x.featureName === tab.featureName
      )
    );
  }
  return (
      <Tabs
        tabs={getTabs()}
        currentTabId={year}
        onTabChange={push}
        dataTest="soc-tabs"
        indicatorColor="black"
      />
  );
};